import { ChangeDetectorRef, Directive, Input, OnChanges, OnDestroy } from '@angular/core';
import { ListingSize } from '@df/catalog-ui/listing/size/listing-size';
import { Subscription } from 'rxjs';

@Directive()
export abstract class ListingSizeComponentDef implements OnChanges, OnDestroy {
    /**
     * Size subscription
     */
    protected sizeSubscription?: Subscription;

    /**
     * Size model
     */
    @Input({
        required: true
    })
    size!: ListingSize;

    constructor(private cd: ChangeDetectorRef) {}

    /**
     * When size changes reset subscription
     */
    ngOnChanges(changes) {
        if (changes.size) {
            this.sizeSubscription?.unsubscribe();
            this.sizeSubscription = this.size.subscribe(() => this.detectChanges());
        }
    }

    /**
     * Cleanup
     */
    ngOnDestroy() {
        this.sizeSubscription?.unsubscribe();
    }

    /**
     * Change detection
     */
    protected detectChanges() {
        // update option buttons on resize
        this.cd.detectChanges();
    }
}
